import React, { Component } from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';  
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {FaList} from 'react-icons/fa';
import { css } from 'aphrodite/no-important';
import Actions from '../../../Actions';
import Logo from '../../../Images/logo-nav.png';
import { navbarStyles } from './styles';


class NavBar extends Component {
    render() {
        const { navbar, logo, navbar_dropdown } = navbarStyles;
        const { auth, toggleSidebar, sideBar } = this.props;
        //UncontrolledDropdown is same as NavItem which translates to dom li.
        return (
            <div>
                <Navbar color="dark" dark className={`shadow py-0 fixed-top ${css(navbar)}`}>
                    <NavbarBrand href="/"><img className={`img-fluid ${css(logo)}`} src={Logo} alt="Niggle" /></NavbarBrand>                
                    <Nav>
                        <UncontrolledDropdown nav className="d-none d-sm-flex">
                            <DropdownToggle nav caret className={css(navbar_dropdown)}>
                                {auth.user.email}
                            </DropdownToggle>
                            <DropdownMenu right>
                                <Link to="logout">
                                    <DropdownItem>
                                        Logout
                                    </DropdownItem>
                                </Link>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <NavItem>
                            { !sideBar? <FaList style={{verticalAlign: "middle", cursor: "pointer"}} size={18} onClick={()=>toggleSidebar(sideBar)}/>: '' }
                        </NavItem>
                    </Nav>
                </Navbar>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth : state.auth,
    sideBar: state.layout.sidebar_toggle,
});
export default connect(mapStateToProps,{...Actions.auth, ...Actions.layout})(NavBar);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/NavBar.js